<template>
  <!-- Siempre en el DOM (position:fixed, sin colapsar el flujo) → evita CLS al montar/desmontar -->
  <div
    class="age-verify-overlay"
    :class="{ 'age-verify-overlay--dismissed': verified }"
    role="dialog"
    aria-modal="true"
    aria-labelledby="age-verify-title"
    :aria-hidden="verified"
    :inert="verified"
  >
    <div class="age-verify-modal">
      <img
        src="@/assets/images/logo.png"
        alt=""
        class="logo"
        width="200"
        height="200"
        decoding="async"
        fetchpriority="high"
      />
      <h2 id="age-verify-title">Verificación de Edad</h2>
      <p class="mb-4">Debes ser mayor de 18 años para acceder a este sitio.</p>
      <div class="d-flex gap-3">
        <button type="button" @click="verify(true)" class="btn btn-primary px-3 py-2 d-inline-flex align-items-center justify-content-center gap-2">
          <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true" focusable="false" class="age-btn-icon">
            <path fill="currentColor" d="M9 16.2 4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z"/>
          </svg>
          Soy mayor de 18
        </button>
        <button type="button" @click="verify(false)" class="btn btn-outline-light px-3 py-2 d-inline-flex align-items-center justify-content-center gap-2">
          <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true" focusable="false" class="age-btn-icon">
            <path fill="currentColor" d="M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
          </svg>
          Soy menor
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';

function readAgeVerified() {
  try {
    return typeof localStorage !== 'undefined' && localStorage.getItem('ageVerified') === 'true';
  } catch {
    return false;
  }
}

/* Estado inicial síncrono = mismo frame que el primer paint de Vue (sin flash por onMounted) */
const verified = ref(readAgeVerified());

const verify = (isAdult) => {
  if (isAdult) {
    localStorage.setItem('ageVerified', 'true');
    verified.value = true;
  } else {
    window.location.href = 'https://www.google.com';
  }
};
</script>

<style scoped>
.age-verify-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.95);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10002;
  transition: opacity 0.2s ease, visibility 0.2s ease;
}

.age-verify-overlay--dismissed {
  visibility: hidden;
  opacity: 0;
  pointer-events: none;
}

.age-verify-modal {
  background: var(--black-color-3);
  padding: 2rem;
  border-radius: 1rem;
  text-align: center;
  max-width: 90%;
  min-height: 350px;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.logo {
  width: 200px;
  height: 200px;
  margin: 0 auto;
  object-fit: contain;
  display: block;
}

h2 {
  color: var(--white-color);
  margin-bottom: 1rem;
  font-size: 1.5rem;
}

p {
  color: var(--white-color-2);
  opacity: 0.8;
}

.btn {
  flex: 1;
  transition: all 0.3s ease;
}

.btn:hover {
  transform: translateY(-2px);
}

.age-btn-icon {
  flex-shrink: 0;
}

@media (max-width: 576px) {
  .age-verify-modal {
    padding: 1.5rem;
  }

  .btn {
    padding: 0.5rem !important;
    font-size: 0.9rem;
  }
}
</style>
